/*eslint-disable*/ export const messages = JSON.parse("{\"radio-group.validation.required\":[\"Välj ett alternativ.\"],\"radio-group.label.optional\":[\"Valfritt\"]}");
//# sourceMappingURL=messages.mjs.map